export const SET_LOGIN = 'APP/LOGIN/SET_LOGIN';

export const SET_ERROR = 'APP/LOGIN/SET_ERROR';
export const SET_IS_LOADING = 'APP/LOGIN/SET_IS_LOADING';
